import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_FAC019_Request,
  IAPI_FAC019_Response,
  IAPI_STA005_Request,
  IAPI_STA005_Response,
  IAPI_STA020_Request,
  IAPI_STA020_Response,
} from "../../../type/apiType";

// プルダウン用有効施設一覧参照
const httpAPI_FAC019 = async (
  param: IAPI_FAC019_Request
): Promise<IAPI_FAC019_Response> => {
  let res = await http.post(ApiUrl.API_FAC019, {
    ...param,
  });

  return res.data;
};

// 職員一覧本俸月額参照
const httpAPI_STA020 = async (
  param: IAPI_STA020_Request
): Promise<IAPI_STA020_Response> => {
  let res = await http.post(ApiUrl.API_STA020, {
    ...param,
  });

  return res.data;
};

// 日々更新法人職員俸給更新
const httpAPI_STA005 = async (
  param: IAPI_STA005_Request
): Promise<IAPI_STA005_Response> => {
  let res = await http.post(ApiUrl.API_STA005, {
    ...param,
  });

  return res.data;
};

export { httpAPI_FAC019, httpAPI_STA020, httpAPI_STA005 };
